import { array, string, object } from 'yup'

const EMAIL_REGEX = /^(.+\@.+\..+)$/i

const validateEmails = (arrayOfUserData, emailToCheck, arrayOfInputEmails) => {
  const userEmails = arrayOfUserData.map((userData) =>
    userData.email.toLowerCase()
  )
  const filteredEmails = arrayOfInputEmails.filter((email) => {
    // filter out the userEmails to prevent them from inviting themselves
    if (userEmails.includes(email.toLowerCase())) {
      return false
    }
    // check if any users are trying to invite the creator, works only with main email of creator for now
    if (email.toLowerCase() === emailToCheck.toLowerCase()) {
      return false
    }
    return true
  })
  return filteredEmails
}

export const submit = (mutate, elementId, currentUserData, creatorEmail) => {
  return ({ emails }, { resetForm, setSubmitting }) => {
    const filteredEmails = validateEmails(currentUserData, creatorEmail, emails)
    // exclude emails that don't match the email regex from being submitted
    const finalEmails = filteredEmails.filter((e) => EMAIL_REGEX.test(e))
    return mutate({ variables: { elementId, emails: finalEmails } }).then(
      () => {
        setSubmitting(false)
        resetForm()
      }
    )
  }
}

export const validationSchema = object().shape({
  // allow any string tags, but ensure at least one valid email is present
  emails: array()
    .of(string())
    .min(1)
    .required()
    .test(
      'has-valid-email',
      'Devi inserire almeno una email valida.',
      (emails) =>
        Array.isArray(emails) && emails.some((e) => EMAIL_REGEX.test(e))
    ),
})
